import { Components, Theme } from "@mui/material";

export const MuiTableRow: Components<Theme>["MuiTableRow"] = {
  variants: [
    {
      props: {
        content: "list",
      },
      style: () => {
        return {
          borderRadius: "1rem",
        };
      },
    },
  ],
};
